export default __webpack_public_path__ + "static/media/favicon.7c67734b.png";